module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5g87y"))).then(() => parcelRequire('cvs7o'));